module.exports = __webpack_public_path__ + "img/light-hail.e21d43ad.svg";